import React from 'react'
import { Modal, Row, Col, Card, Typography, theme } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCreditCard, faCoins, faHeartPulse, faMoneyBill } from '@fortawesome/free-solid-svg-icons'
import { hexToRGBA } from '../../../../../lib/utils'

const PaymentMethodModal = ({
  paymentMethodChange,
  setPaymentMethodChange,
  currentRecord,
  setCurrentRecord,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  paymentMethods,
  handleChangePaymentMethod
}) => {
  const { token } = theme.useToken()

  // Helper function to get payment method icons
  const getPaymentIcon = (method) => {
    switch (method.toLowerCase()) {
      case 'card':
        return faCreditCard
      case 'cash':
        return faCoins
      case 'medical aid':
        return faHeartPulse
      default:
        return faMoneyBill
    }
  }

  return (
    <Modal
      open={paymentMethodChange}
      title='Change Payment Method'
      okText='Submit'
      cancelText='Cancel'
      onOk={handleChangePaymentMethod}
      onCancel={() => {
        setPaymentMethodChange(false)
        setCurrentRecord(null)
        setSelectedPaymentMethod('')
      }}
      closable={false}
      maskClosable={false}
      destroyOnClose
      width={600}
    >
      <Row gutter={[16, 16]}>
        {paymentMethods.map((method) => (
          <Col xs={24} sm={12} md={8} key={method.value}>
            <Card
              size='small'
              style={{
                borderRadius: '12px',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                height: '100px',
                border: `2px solid ${
                  method.value === selectedPaymentMethod ? token.colorPrimary : hexToRGBA(token.colorBorder, 0.2)
                }`,
                background: method.value === selectedPaymentMethod ? hexToRGBA(token.colorPrimary, 0.08) : '#fff',
                boxShadow:
                  method.value === selectedPaymentMethod
                    ? '0 4px 20px rgba(24, 144, 255, 0.15)'
                    : '0 2px 8px rgba(0,0,0,0.06)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              className='payment-method-card'
              bodyStyle={{
                padding: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                width: '100%'
              }}
              onClick={() => setSelectedPaymentMethod(method.value)}
            >
              {/* Center content - Icon and Text */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '8px',
                  flex: 1
                }}
              >
                <FontAwesomeIcon
                  icon={getPaymentIcon(method.label)}
                  style={{
                    fontSize: '28px',
                    color: token.colorPrimary
                  }}
                />
                <Typography.Text
                  style={{
                    fontSize: '14px',
                    fontWeight: '500',
                    textAlign: 'center'
                  }}
                >
                  {method.label}
                </Typography.Text>
              </div>

              {/* Checkmark indicator for selected state */}
              {method.value === selectedPaymentMethod && (
                <div
                  style={{
                    position: 'absolute',
                    top: '8px',
                    right: '8px',
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    backgroundColor: token.colorPrimary,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <span style={{ color: '#fff', fontSize: '12px', fontWeight: 'bold' }}>✓</span>
                </div>
              )}
            </Card>
          </Col>
        ))}
      </Row>

      <style jsx global>{`
        .payment-method-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
          border-color: ${token.colorPrimary} !important;
        }
      `}</style>
    </Modal>
  )
}

export default PaymentMethodModal
